exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".modal-button{display:inline-block;margin-right:2.5rem;font-size:.75rem}.modal-button:last-child{margin-right:0}.modal-button__icon{width:2.5rem;height:2.5rem;margin:0 auto;margin-bottom:.25rem;padding:.5rem;background:#516a7d;border-radius:50%}.modal-button__icon svg{width:100%;height:100%}.modal-button__icon svg path,.modal-button__icon svg polygon,.modal-button__icon svg rect{fill:#9ecef3}.modal-button[disabled]{opacity:.4;pointer-events:none}.modal-button.modal-button--cancel .modal-button__icon{background:#374651}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./src/components/ModalButton/ModalButton.scss
// module id = 685
// module chunks = 0